import { getPendingDiscount, pricingPath } from "./pendingDiscount";

const AUTH_PAGES = ["/login", "/register", "/password-reset", "/password-reset-request"];

// Only same-site paths, never back to an auth page.
export const safePath = (raw) => {
  if (typeof raw !== "string" || !raw.startsWith("/")) return null;
  if (raw.startsWith("//") || raw.startsWith("/\\")) return null;
  if (AUTH_PAGES.includes(raw.split(/[?#]/)[0])) return null;
  return raw;
};

// Where the visitor was heading before being asked to sign in: the route
// state set by ProtectedRoute / "sign in to subscribe", else ?next= (full page
// reloads such as an expired session), else the pricing page when they
// brought a discount code, else the dashboard.
export const authDestination = (location) => {
  const fromState = safePath(location?.state?.from);
  if (fromState) return fromState;
  let next = null;
  try {
    next = safePath(new URLSearchParams(location?.search || "").get("next"));
  } catch (_) {}
  if (next) return next;
  const code = getPendingDiscount();
  if (code) return pricingPath(code);
  return "/app";
};

// Carry the destination along when moving between login, sign-up and
// password reset.
export const authCarry = (location) => {
  const dest = safePath(location?.state?.from);
  if (dest) return { from: dest };
  try {
    const next = safePath(new URLSearchParams(location?.search || "").get("next"));
    if (next) return { from: next };
  } catch (_) {}
  return undefined;
};

export const loginPathFor = (dest) => {
  const safe = safePath(dest);
  return safe ? `/login?next=${encodeURIComponent(safe)}` : "/login";
};
